import countryList from 'country-list';

export const autoOptions = type => {
    switch (type) {
        case "Countries":
        case "countries":
            return countryList.getNames();
    }
};